import { InfiniteList } from '@src/design-system/molecules/infinite-list';

import { type ComponentProps, type ElementType, useRef } from 'react';
import { ItemInfo } from '@features/tasks/pages/create/item-info';
import type { TLeadReferal } from '@shared/types/lead-referal';
import leadReferalApi, {
  type TReferalsListQuery,
} from '@features/leads/services/lead-referal-api';

export const ReferalsList = ({
  onClickItem,
  isItemSelected,
  CloseListTrigger,
  props,
}: {
  onClickItem?: (item: TLeadReferal, isSelected: boolean) => void;
  isItemSelected?: (item: TLeadReferal) => boolean;
  CloseListTrigger?: ElementType;
  props?: {
    infiniteListProps?: Partial<
      ComponentProps<typeof InfiniteList<TLeadReferal, TReferalsListQuery>>
    >;
    infoItemProps?: Partial<
      ComponentProps<typeof ItemInfo<TReferalsListQuery>>
    >;
  };
}) => {
  const ref = useRef<HTMLButtonElement>(null);

  return (
    <>
      <InfiniteList<TLeadReferal, Partial<TReferalsListQuery>>
        enableSearch
        fetchInfiniteData={leadReferalApi.useFetchInfinite}
        searchParamName='referal'
        props={{ listProps: { className: 'gap-0' } }}
        renderItem={(referal) => {
          const isSelected = isItemSelected?.(referal);
          return (
            <ItemInfo
              item={referal}
              id={referal.id}
              onClick={() => {
                ref.current?.click();
                onClickItem?.(referal, !!isSelected);
              }}
              isSelected={isSelected}
              name={referal.name}
              className='border-none '
              {...props?.infoItemProps}
            />
          );
        }}
        {...props?.infiniteListProps}
      />
      {CloseListTrigger && (
        <CloseListTrigger
          ref={ref}
          className='hidden'
        />
      )}
    </>
  );
};
